module.exports = __webpack_public_path__ + "img/heart_14_bj.a2ad2ef0.png";